<template>
  <b-tabs pills align="center">
    <b-tab title="By user types" class="nav-item" active>
      <b-card-text class="view-heading my-3">
        Estimated cost by user type
      </b-card-text>
      <b-row>
        <b-col
          cols
          lg="6"
          md="12"
          sm="auto"
          v-for="(viewByPersona, index) in viewByPersona"
          :key="index"
        >
          <Card class="mb-3">
            <b-row>
              <b-col cols="9" class="solid-border">
                <p class="pills-card-title">
                  {{ viewByPersona.persona }}
                </p>
                <p class="persona-info mb-2">
                  {{ viewByPersona.users }} Users |
                  {{ viewByPersona.workerOS }}
                </p>
                <Graph
                  :data="[viewByPersona.cvad, viewByPersona.perMonthPerUser]"
                  :inlineData="true"
                />
              </b-col>
              <b-col cols="3" class="per-user-per-month">
                <p class="pills-card-data">
                  ${{ viewByPersona.perMonthPerUserValue.toFixed(2) }}
                </p>
                <p class="persona-info">Per user/month</p>
              </b-col>
            </b-row>
          </Card>
        </b-col>
      </b-row>
      <div class="legends">
        <div class="graph-pointers">
          <div class="purple"></div>
          Citrix costs
        </div>
        <div class="graph-pointers">
          <div class="blue"></div>
          Google Cloud costs
        </div>
      </div>
    </b-tab>
    <b-tab title="Grid view">
      <b-card-text class="view-heading my-3">
        Estimated cost
      </b-card-text>
      <GridView :gridData="griddata" />
    </b-tab>
    <b-tab title="By region">
      <b-card-text class="view-heading my-3">
        Estimated cost by region
      </b-card-text>
      <b-row>
        <b-col
          cols
          lg="6"
          md="12"
          sm="auto"
          v-for="(viewByPersonaByRegion, index) in Object.keys(viewByRegion)"
          :key="index"
        >
          <Card class="mb-3">
            <b-row>
              <b-col cols="9" class="solid-border">
                <p class="pills-card-title">
                  {{ viewByPersonaByRegion }}
                </p>
                <p class="persona-info">
                  {{ viewByRegion[`${viewByPersonaByRegion}`].users }}
                  Users
                </p>
                <Graph
                  :data="[
                    viewByRegion[`${viewByPersonaByRegion}`].cvadCost,
                    viewByRegion[`${viewByPersonaByRegion}`]
                      .perMonthPerUserValue,
                  ]"
                  :inlineData="true"
                />
              </b-col>
              <b-col cols="3" class="per-user-per-month">
                <p class="pills-card-data">
                  ${{
                    viewByRegion[`${viewByPersonaByRegion}`].permonth.toFixed(2)
                  }}
                </p>
                <p class="persona-info">Per user/month</p>
              </b-col>
            </b-row>
          </Card>
        </b-col>
      </b-row>
      <div class="legends">
        <div class="graph-pointers">
          <div class="purple"></div>
          Citrix costs
        </div>
        <div class="graph-pointers">
          <div class="blue"></div>
          Google Cloud costs
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import store from '../../store/index';
import Card from '../global/Card.vue';
import Graph from '../global/Graph.vue';
import GridView from './GridView.vue';
import { cvadCostCalculationFunction } from '../../services/lib/CVADcalculation';
export default {
  name: 'TabView',
  data() {
    return {
      griddata: [],
      viewByPersona: [],
      viewByRegion: {},
      estimatedPrice: [],
      cvadCost: 0,
      cvadCostPerUser: 0,
      gcpCost: {
        compute: 0,
        storage: 0,
      },
    };
  },
  components: {
    Card,
    Graph,
    GridView,
  },
  mounted() {
    let regions = {};
    store.state.personaDataAfterCalculate.sort((a, b) => a.id - b.id);

    store.state.personaData.forEach((item, id) => {
      //for cvad calculation each persona cvadpermonth value is calculated and added in this variable
      var totalCvadCostPerYear = 0;
      var totalCvadPerUserPerYearCost = 0; // for cvad calculation per year per year values

      var totalCvadCostThreeYear = 0;
      totalCvadCostPerYear =
        totalCvadCostPerYear +
        cvadCostCalculationFunction(item.pricingModel, item.users).totalCost;
      //calculating the three years data for different pricing model
      /*section start */
      // if (item.pricingModel == 'PAYGO') {
      //per-user per-year
      totalCvadPerUserPerYearCost =
        totalCvadPerUserPerYearCost +
        cvadCostCalculationFunction(item.pricingModel, item.users)
          .cvadCostperUserperYearValue;
      //for 3 years
      totalCvadCostThreeYear =
        totalCvadCostThreeYear +
        cvadCostCalculationFunction(item.pricingModel, item.users).totalCost *
          3;
      // } else {
      //   const totalValueBeforeDiscount =
      //     cvadCostCalculationFunction(item.pricingModel, item.users).totalCost *
      //     3;
      //   const totalValueBeforeDiscountPerYearPerUser = cvadCostCalculationFunction(
      //     item.pricingModel,
      //     item.users
      //   ).cvadCostperUserperYearValue;

      //   const totalValueAfterDiscount =
      //     totalValueBeforeDiscount - totalValueBeforeDiscount * (20 / 100);
      //   const totalValueAfterDiscountPerYearPerUser =
      //     totalValueBeforeDiscountPerYearPerUser -
      //     totalValueBeforeDiscountPerYearPerUser * (20 / 100);

      //   totalCvadPerUserPerYearCost =
      //     totalCvadPerUserPerYearCost + totalValueAfterDiscountPerYearPerUser;

      //   totalCvadCostThreeYear =
      //     totalCvadCostThreeYear + totalValueAfterDiscount;
      // }

      /*section end */

      let compute = 0;
      let storage = 0;
      let counter = store.state.personaDataAfterCalculate.filter(
        ele =>
          ele.regionId === store.state.personaDataAfterCalculate[id].regionId
      ).length;
      compute +=
        store.state.personaDataAfterCalculate[id].cloudConnector.compute /
          counter +
        store.state.personaDataAfterCalculate[id].domainController.compute +
        store.state.personaDataAfterCalculate[id].netScaler.compute +
        store.state.personaDataAfterCalculate[id].storeFront.compute +
        store.state.personaDataAfterCalculate[id].vda.compute;

      storage +=
        store.state.personaDataAfterCalculate[id].cloudConnector.storage /
          counter +
        store.state.personaDataAfterCalculate[id].domainController.storage +
        store.state.personaDataAfterCalculate[id].netScaler.storage +
        store.state.personaDataAfterCalculate[id].storeFront.storage +
        store.state.personaDataAfterCalculate[id].vda.storage;

      compute = compute * 12;
      storage = storage * 12;

      this.gcpCost.compute = compute;
      this.gcpCost.storage = storage;

      //calculations for by region personas
      if (regions[store.state.allPersonaFormData[id][3].labelvalue]) {
        regions[store.state.allPersonaFormData[id][3].labelvalue][
          'users'
        ] += Number(item.users);
        regions[store.state.allPersonaFormData[id][3].labelvalue]['count'] += 1;
        regions[store.state.allPersonaFormData[id][3].labelvalue][
          'permonth'
        ] += Number(
          totalCvadPerUserPerYearCost / 12 +
            (compute + storage) / 12 / Number(item.users)
        ).toFixed(2);

        //used to display the cvad part of the graph.
        regions[store.state.allPersonaFormData[id][3].labelvalue][
          'cvadCost'
        ] += totalCvadCostThreeYear;

        regions[store.state.allPersonaFormData[id][3].labelvalue][
          'perMonthPerUserValue'
        ] += (compute + storage) / 12 / Number(item.users);
      } else {
        regions[store.state.allPersonaFormData[id][3].labelvalue] = {
          users: Number(item.users),
          count: 1,
          permonth:
            totalCvadPerUserPerYearCost / 12 +
            (compute + storage) / 12 / item.users,
          cvadCost: totalCvadCostThreeYear,
          perMonthPerUserValue: (compute + storage) / 12 / Number(item.users),
        };
      }

      const tempobj = {};
      const viewByPersona = {};

      //data being added for each row of the grid
      tempobj['User types'] = item.config;
      tempobj['Region'] = store.state.allPersonaFormData[id][3].labelvalue;
      tempobj['Users'] = item.users;
      tempobj['Term options'] =
        item.pricingModel === 'Commit3Yr' ? '3 Yr Term' : 'Monthly';

      tempobj['3 Yr Term'] = Number(
        (totalCvadCostThreeYear + (compute + storage) * 3).toFixed(2)
      );
      tempobj['Per annum'] = Number(
        (totalCvadCostThreeYear / 3 + (compute + storage)).toFixed(2)
      );
      tempobj['Per month'] = (
        totalCvadCostThreeYear / 36 +
        (compute + storage) / 12
      ).toFixed(2);

      tempobj['Per month/User'] = Number(
        (
          totalCvadPerUserPerYearCost / 12 +
          (compute + storage) / item.users / 12
        ).toFixed(2)
      );

      this.griddata.push(tempobj);

      //data for viewbypersona tab
      viewByPersona['persona'] = item.config;
      viewByPersona['users'] = item.users;
      viewByPersona['workerOS'] = item.workerOS;
      viewByPersona['regionId'] = item.regionId;
      viewByPersona['perMonthPerUserValue'] = Number(
        totalCvadPerUserPerYearCost / 12 + (compute + storage) / item.users / 12
      );
      viewByPersona['perMonthPerUser'] = Number(
        (compute + storage) / item.users / 12
      );
      viewByPersona['cvad'] = 10;
      this.viewByPersona.push(viewByPersona);
    });

    Object.keys(regions).map(item => {
      regions[item].cvadCost = 10;
      regions[item].perMonthPerUserValue =
        regions[item].perMonthPerUserValue / regions[item].count;
      regions[item].permonth =
        regions[item].perMonthPerUserValue + regions[item].cvadCost;
    });

    this.viewByRegion = regions;
  },
};
</script>

<style lang="scss" scoped>
p {
  padding-top: 0%;
  font-weight: 300;
}

.legends {
  display: flex;
}
.solid-border {
  border-right: 1px solid rgba(177, 177, 177, 0.25);
}
@media screen and (min-width: 601px) {
  .view-heading {
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 600px) {
  .view-heading {
    font-size: 20px;
    margin-bottom: 0;
  }
}

.pills-card-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 5px;
  font-size: 20px;
}

.persona-info {
  font-size: 16px;
  font-weight: 100;
  color: $light;
}

.per-user-per-month {
  margin: auto;
  text-align: center;
}

.pills-card-data {
  @extend .view-heading;
  margin: 0;
  font-size: 28px;
  font-weight: 300;
  color: #000;
}

.graph-pointers {
  font-size: 12px;
  display: flex;
  padding: 10px;
}

/deep/ .nav-pills .nav-link {
  color: #000000 !important;
  border: 1px solid #b1b1b1;
  border-radius: 25px;
  padding: 0.2rem 1rem;
  margin-left: 8px;
  text-decoration: none;
  margin-top: 10px;
  font-size: 20px;
}

/deep/ .nav-pills .nav-link .active,
/deep/ .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  outline: none !important;

  color: #000000 !important;
  border: 1px solid #b1b1b1;
  border-radius: 25px;
  padding: 0.2rem 1rem;
  margin-left: 8px;
  text-decoration: none;
  margin-top: 10px;
  font-size: 20px;
  background-color: $secondary !important;
  box-shadow: 4px 8px 10px 3px #d9d9d9;
}
.purple {
  width: 12px;
  height: 12px;
  background-color: $graph-primary;
  margin-right: 6px;
  margin-top: 2px;
}
.blue {
  width: 12px;
  height: 12px;
  margin-right: 6px;
  margin-top: 2px;
  background-color: $graph-secondary;
}

@media print {
  .tabs {
    margin-top: 20vh;
  }
}

@media (max-width: 768px) {
  .persona-info {
    font-size: 11px;
  }
  .pills-card-data {
    margin: 0;
    font-size: 18px;
    font-weight: 300;
    color: #000;
  }
}
/* Safari 10.1+ (alternate method) */

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    :-webkit-direct-focus {
      outline: none !important;
    }
  }
}
</style>
